module.exports = __webpack_public_path__ + "static/media/house_16.db3fdf73.jpg";